import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import dialogsManagerActions from '../../redux/actions/dialogsManager.actions';
import hooks from './hooks';

import CustomClickableBoxList from '../common/boxes/custom-clickable-box-list';
import CustomDialog from '../common/custom-dialog';

import useStyles from './styles';

export function StockOutIssueSuggestionsDialog() {
  const componentClasses = useStyles();

  const description = hooks.useDescription();
  const open = hooks.useOpen();
  const options = hooks.useOptions();
  const title = hooks.useTitle();

  const dispatch = useDispatch();

  const handleBack = useCallback(() => {
    dispatch(dialogsManagerActions.back());
  }, [dispatch]);

  const handleClose = useCallback(() => {
    dispatch(dialogsManagerActions.close());
  }, [dispatch]);

  return (
    <CustomDialog
      classes={{
        childrenContainer: componentClasses.childrenContainer,
        headerRoot: componentClasses.headerRoot,
        paper: componentClasses.paper,
      }}
      onClickBackButton={handleBack}
      onClose={handleClose}
      open={open}
      showBackButton
      showCloseButton
      title={title}
    >
      <CustomClickableBoxList label={description} options={options} />
    </CustomDialog>
  );
}
